import { VideoLibrary } from "@/components/VideoLibrary";
import React from "react";

export default function StoryblokVideoLibraryEntry({ blok }: { blok: any }) {
  return <VideoLibrary video={blok} />;
}
